var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 160,
    viewBox: "0 0 145 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.287 110.896C128.37 110.896 123.572 115.718 123.572 121.667V138.456H21.4262V121.667C21.4262 115.718 16.6298 110.896 10.7131 110.896C4.79645 110.896 0 115.718 0 121.667V149.227C0 155.176 4.79645 160 10.7131 160H134.287C140.203 160 145 155.176 145 149.227V121.667C145 115.718 140.203 110.896 134.287 110.896Z",
    fill: "url(#paint0_linear_2733_587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.266 122.356C71.0505 124.149 73.9495 124.149 75.7322 122.356L113.277 84.6081C114.371 83.5083 114.696 81.8563 114.104 80.4152C113.513 78.98 112.122 78.0443 110.572 78.0443H92.9432V8.40611C92.9432 3.76103 89.2024 0 84.5834 0H60.4205C55.8018 0 52.0607 3.7607 52.0607 8.40611V78.0443H34.4259C32.8775 78.0443 31.4865 78.9797 30.895 80.4152C30.3035 81.8563 30.6287 83.5083 31.721 84.6081L69.266 122.356Z",
    fill: "url(#paint1_linear_2733_587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2733_587",
    x1: 72.5,
    y1: 110.896,
    x2: 72.5,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2733_587",
    x1: 72.4997,
    y1: 0,
    x2: 72.4997,
    y2: 123.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIcon);
export default __webpack_public_path__ + "static/media/studyIcon.121a54f75bbf877933f285d70459b7f5.svg";
export { ForwardRef as ReactComponent };